export enum CarnetType {
  ABSENCE = "ABSENCE",
  EMPLOYED = "EMPLOYED",
}
